import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackBarTheme } from '../models/snackbar-theme.enum';
import { AccountService } from '../services/account/account.services';
import { ProductsService } from '../services/product/product.services';
import { TranslationConstants } from '../services/util/translation.constants';
import { SnackbarComponent } from '../snackbar/snackbar.component';

@Component({
  selector: 'app-waitlist-modal',
  templateUrl: './waitlist-modal.component.html',
  styleUrls: ['./waitlist-modal.component.scss']
})
export class WaitlistModalComponent implements OnInit {

  public isLogged = false;
  public loggedUser: any = { email: 'arlindo@email.com'};
  public email: string = undefined;
  public loading: boolean = false;
  public validated: boolean;

  constructor(
    public dialogRef: MatDialogRef<WaitlistModalComponent>,
    private readonly accountService: AccountService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly productService: ProductsService,
    private readonly translationConstants: TranslationConstants,
    private readonly snackbarComponent: SnackbarComponent,
  ) { }

  ngOnInit(): void {
    this.getLoggedUser();
  }

  getLoggedUser(): void {
    // Buscar no  serviço o usuário logado
    this.accountService.isAuthenticated(true).subscribe(success => {
      if(success) {
        this.accountService.getUserDetails().subscribe(user => {
          this.isLogged = true;
          this.email = user.email;
          this.validated = true;
        });
      }
    });
  }

  close() {
    this.dialogRef.close();
  }


  public validate() {
    this.validated =  /\S+@\S+\.\S+/.test(this.email);
  }

  assign() {
    this.loading = true;
    this.productService.createWatch(this.data, this.email).subscribe(data => {
      this.snackbarComponent.openSnackBar(this.translationConstants.translate('watchlistDialog.success'), SnackBarTheme.success, 4000);
      setTimeout(() => {
        this.close();
      }, 1000)
    }).add(() => {
      this.loading = false;
    })
  }

}
